import { CommonModule } from "@angular/common";
import { Component, Input, inject } from "@angular/core";
import { Router } from "@angular/router";
import { NewBaseService } from "@providers/newBase.service";
import { SPORTS_PATHS } from "@shared-constants/routes";
import { SportNavigationService } from "@sports-services/index";

@Component({
  selector: "sb-simple-navbar",
  templateUrl: "./sb-simple-navbar.html",
  styleUrls: ["./sb-simple-navbar.scss"],
  standalone: true,
  imports: [CommonModule],
  host: {
    class: "sb-simple-navbar",
  },
})
export class SbSimpleNavbarComponent {
  @Input() hasBackButton: boolean;
  @Input() fakeButton = false;

  sportNavigationService = inject(SportNavigationService);
  newBaseService = inject(NewBaseService);
  router = inject(Router);

  navigate() {
    if (this.fakeButton) {
      this.router.navigateByUrl(`/${SPORTS_PATHS.HomePage}`);
    } else {
      try {
        this.sportNavigationService.back();
      } catch (error) {
        this.router.navigateByUrl(`/${SPORTS_PATHS.HomePage}`);
      }
    }
  }
}
